import { GET_COMMENTS } from 'src/constants';
import { axios } from 'src/lib';
import {
  CommentDataPayload,
  ICommentsDetailModel
} from '../../../../pricing-simulator/components/comment-box-container/comment-box-container.model';

export default function fetchCommentsForRow(
  commentDataBody: CommentDataPayload,
  scenarioId: number
) {
  return axios
    .post<{ data: ICommentsDetailModel }>(
      `${GET_COMMENTS}${scenarioId}/`,
      commentDataBody
    )
    .then((response) => response.data);
}
